import { render } from "./Review.vue?vue&type=template&id=dadf529e&scoped=true"
import script from "./Review.vue?vue&type=script&lang=ts"
export * from "./Review.vue?vue&type=script&lang=ts"

import "./Review.vue?vue&type=style&index=0&id=dadf529e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dadf529e"

export default script